"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "falerna": {
    "aa7551bf": [{
      "hkey": "b7a28a17",
      "slug": "cartolano-torre-lupo",
      "name": "Cartolano-Torre Lupo",
      "primary": true,
      "skipSearch": false
    }],
    "cartolano": [{
      "hkey": "b7a28a17",
      "slug": "cartolano-torre-lupo",
      "name": "Cartolano-Torre Lupo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "falerna-marina"
    }],
    "6d6eafe5": [{
      "hkey": "4a2371c1",
      "slug": "falerna-scalo",
      "name": "Falerna Scalo",
      "primary": true,
      "skipSearch": false
    }],
    "localita-falerna-scalo": [{
      "hkey": "4a2371c1",
      "slug": "falerna-scalo",
      "name": "Falerna Scalo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "falerna-marina"
    }]
  }
};
exports["default"] = _default;